

import { configureStore } from "@reduxjs/toolkit"
import APIResponseSlice from "./slices/APIResponseSlice"

export const store = configureStore({
  reducer: {
    // MSALAuth: APISlice,
    APIResponse: APIResponseSlice,
  },
})
